import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { PartiesComponent } from '../parties/parties.component';
import { ePartySubType, ePartyType, Order, OrderManagerService, PartiesListComponent, Party, PartyForCreation, PartyRepositoryService, ReusableParty, ReusablePartyRepositoryService, UIConfigurationService, Utilities, ValidationProblem, ValidationService } from 'reg-hub-common';
import { HttpParams } from '@angular/common/http';
import { StepValidationState } from 'projects/reg-hub-client/src/interfaces/step';

@Component({
    selector: 'app-assignors',
    templateUrl: './assignors.component.html',
    styleUrl: './assignors.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssignorsComponent extends PartiesComponent {
  @ViewChild(PartiesListComponent) partiesListComponent!: PartiesListComponent;

  reusableSecuredParties: ReusableParty[] = [];

  protected businessSecuredParty = ePartyType.businessSecuredParty;
  protected individualSecuredParty = ePartyType.individualSecuredParty;

  constructor(
    private reusablePartyRepo: ReusablePartyRepositoryService,
    partyRepo: PartyRepositoryService,
    uiConfigurationService: UIConfigurationService,
    orderManager: OrderManagerService,
    validationService: ValidationService) {
    super(partyRepo, uiConfigurationService, orderManager, validationService);
  }

  protected override init(order: Order): void {
    super.init(order);

    // the order's "Request For" user group's reusables, or the corporation's when the group falls back to them
    this.reusablePartyRepo.populateScopedBaseLink(this.order.orderGroup!.corporationID, this.order.userGroupID);
    var reusablePartyParams = new HttpParams().set('isVisible', true).set('UseCorporationFallback', true)
      .set('pageSize', 100)
      .append('PartyTypeIDs', 'BusinessSecuredParty')
      .append('PartyTypeIDs', 'IndividualSecuredParty');

    this.reusablePartyRepo.getFirstPageSubscribable(reusablePartyParams).subscribe(parties => {
      this.reusableSecuredParties = parties;
    });
  }

  public override getValidationState(errors: ValidationProblem[] | undefined, order: Order): StepValidationState {
    return PartiesComponent.parseErrorsForValidationState(errors, order, Utilities.isAssignor);
  }

  public override getParties(): Party[] {
    const filteredSecuredParties = this.order.parties?.filter((party: Party) => Utilities.isAssignor(party));
    return filteredSecuredParties ?? [];
  }

  override onSaving(): void {
    var partyToReplace = this.partiesListComponent.onSaving();
    if (partyToReplace) {
      partyToReplace.partySubType = ePartySubType.assignor;
      this.replaceParty(partyToReplace!);
    }
  }

  override handlePartyAddedEvent(addedParty: Party) {
    addedParty.partySubType = ePartySubType.assignor;
    super.handlePartyAddedEvent(addedParty);
  }

  override handleExistingPartySaveEvent(existingParty: PartyForCreation) {
    existingParty.partySubType = ePartySubType.assignor;
    super.handleExistingPartySaveEvent(existingParty);
  }

  override handleExistingLinkedPartySaveEvent(existingParties: PartyForCreation[]) {
    existingParties.forEach(p => p.partySubType = ePartySubType.assignor);
    super.handleExistingLinkedPartySaveEvent(existingParties);
  }

  override handlePartySavedEvent(savedParty: Party) {
    savedParty.partySubType = ePartySubType.assignor;
    super.handlePartySavedEvent(savedParty);
  }
}

